import React, { useState, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import TextInputTwoRow from "components/GenericComponent/TextInputTwoRow";
import {
  getListCongNoThanhLy,
  updateDataSearch,
} from "../../../../actions/CongNoThanhLy";
import { useSelector, useDispatch } from "react-redux";
import { currentDate } from "utils/formatDate";
import { convertToNumber } from "utils/numberExtension";
import { pushNotification } from "utils/notifications";
import CongNoThanhLyApi from "service/congNoThanhLyApi";
import DateTimePicker from "components/GenericComponent/DateTimePicker";
import { formatNumber } from "utils/currencyFormat";
import { getDate } from "utils/formatDate";
import { formatDayMonth } from "utils/formatDate";
import InputDocTien from "components/GenericComponent/NumberInput/InputDocTien";

import { Controller, useForm } from "react-hook-form";

export const ThanhToan = (props) => {
  const currentForm = useForm();
  const { control } = currentForm;
  const dataSearch = useSelector((state) => state.dataSearchCongNoThanhLy); //dataSearchTaiSan dinh nghia o rootreducer
  const dispatch = useDispatch();
  const initData = {
    ThanhLyId: props.ThanhLyId,
    NgayThanhLy: new Date(),
    TienThanhLy: props.conNo,
    GhiChu: "",
  };
  const [dataThanhToan, setDataThanhToan] = useState(initData);

  const updateTextValue = (field) => (e) => {
    setDataThanhToan({
      ...dataThanhToan,
      [field]: e.target.value,
    });
  };

  const onChangeDate = (field) => (evt) => {
    setDataThanhToan({
      ...dataThanhToan,
      [field]: evt,
    });
  };

  const updateDropdown = (field) => (e) => {
    setDataThanhToan({
      ...dataThanhToan,
      [field]: e.value,
    });
  };

  const onChangeNumber = (field) => (e) => {
    setDataThanhToan({
      ...dataThanhToan,
      [field]: convertToNumber(e.target.value),
    });
  };

  const onChangeNumber1 = (field) => (e) => {
    setDataThanhToan({
      ...dataThanhToan,
      [field]: convertToNumber(e.value),
    });
  };

  const initErrors = {
    tienThanhLy: "",
  };
  const [errors, setErrors] = useState(initErrors);
  const [IsDisable, setIsDisable] = useState(false);
  const TienThanhLy = React.createRef();
  const onSubmit = () => {
    if (dataThanhToan.TienThanhLy === 0) {
      setErrors({
        ...errors,
        tienThanhLy: "Nhập số tiền thanh toán",
      });
      TienThanhLy.current.focus();
    } else if (dataThanhToan.TienThanhLy > convertToNumber(props.conNo)) {
      setErrors({
        ...errors,
        tienThanhLy: "Tiền thanh toán không được lớn hơn tiền còn nợ",
      });
      TienThanhLy.current.focus();
    } else {
      setIsDisable(true);
      CongNoThanhLyApi.thanhToan(
        dataThanhToan.ThanhLyId,
        formatDayMonth(dataThanhToan.NgayThanhLy),
        dataThanhToan.TienThanhLy,
        dataThanhToan.GhiChu
      ).then((response) => {
        dispatch(getListCongNoThanhLy(dataSearch));
        props.onHide();
        pushNotification(
          "Bạn đã thanh toán thành công",
          "success",
          "TOP_CENTER",
          1000
        );
      });
    }
    // if (dataThanhToan.TienThanhLy === 0) {
    //   errors.TienThanhLy = {
    //     message: "Nhập tên khách hàng",
    //   };
    //   dataThanhToan.TienThanhLy.current.focus();
    //   seterrors({ errors });
    //   return;
    // } else {
    //   errors.TienThanhLy = null;
    //   seterrors({ errors });
    // }
    // console.log(props);
  };

  const closeThemMoi = () => () => {
    dispatch(getListCongNoThanhLy(dataSearch));
    props.onHide();
  };
  return (
    <Modal
      {...props}
      size="modal-dialog"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left popup-detail"
    >
      <Modal.Header>
        <h4 className="modal-title" id="myModalLabel16">
          <span className="btn-icon-right">
            <i className="far fa-credit-card"></i>
          </span>{" "}
          Thanh Toán
        </h4>
        <button
          type="button"
          className="close-popup-new"
          data-dismiss="modal"
          aria-label="Close"
          onClick={props.onHide}
        >
          <i className="mdi mdi-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <form className="form tat-toan form-horizontal">
          <div className="form-body">
            <div className="form-body">
              <div className="form-group row">
                <label className="col-md-4 label-control text-left">
                  Còn nợ
                </label>
                <div className="col-md-8">{props.conNo} (vnđ)</div>
              </div>
              <div className="form-group row">
                <label className="col-md-4 label-control text-left">
                  Ngày thanh toán
                </label>
                <div className="col-md-8">
                  <DateTimePicker
                    onChange={onChangeDate("NgayThanhLy")}
                    value={dataThanhToan.NgayThanhLy}
                    name="NgayThanhLy"
                    placeholder="Đến ngày"
                  />
                </div>
              </div>
              {/* <TextInputTwoRow
                labelClass="col-md-4 label-control"
                inputClass="form-control input-sm"
                inputWrapClass="col-md-8"
                wrapperClass="form-group row"
                labelText="Số tiền thanh toán"
                inputProps={{
                  name: "customer.Phone",
                  onChange: onChangeNumber("TienThanhLy"),
                  value: formatNumber(dataThanhToan.TienThanhLy),
                }}
              ></TextInputTwoRow> */}
              <InputDocTien
                labelClass="col-md-4 label-control"
                inputClass="form-control input-sm"
                inputWrapClass="col-md-8"
                wrapperClass="form-group row"
                labelText="Số tiền thanh toán"
                placeholder="10,000,000"
                inputProps={{
                  name: "customer.Phone",
                  onChange: onChangeNumber1("TienThanhLy"),
                  value: dataThanhToan.TienThanhLy,
                  getInputRef: TienThanhLy,
                  control: control,
                }}
              ></InputDocTien>
              <div className="form-group row" style={{ marginBottom: "0px" }}>
                <label className="col-md-4 label-control text-left"></label>
                <div
                  className="col-md-8"
                  style={{ marginBottom: "5px", marginTop: "-5px" }}
                >
                  {errors.tienThanhLy && (
                    <span className="canh-bao-red">{errors.tienThanhLy}</span>
                  )}
                </div>
              </div>

              <div className="form-group row">
                <label className="col-md-4 label-control text-left">
                  Ghi chú
                </label>
                <div className="col-md-8">
                  <textarea
                    id="projectinput8"
                    rows="3"
                    className="form-control input-sm"
                    name="comment"
                    value={dataThanhToan.GhiChu}
                    onChange={updateTextValue("GhiChu")}
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer className="modal-footer button-popup-new-size">
        <a
          className="btn btn-new-main btn-checknew"
          href={() => false}
          onClick={onSubmit}
          disabled={IsDisable}
          style={{
            pointerEvents: IsDisable ? "none" : "auto",
            opacity: IsDisable ? 0.6 : 1,
          }}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-check"></i>
          </span>{" "}
          Thanh toán
        </a>

        <a
          className="btn btn-new-main btn-closenew"
          data-dismiss="modal"
          href={() => false}
          onClick={props.onHide}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-close"></i>
          </span>{" "}
          Đóng
        </a>
      </Modal.Footer>
    </Modal>
  );
};
